import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraInput } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { EmptyState } from '../../../components/layout';
import { useDebounce } from '../../../hooks/useDebounce';
import { EntityTable } from '../_shared/components/EntityTable';
import { useGovernmentOrganizations } from '../Programs/referenceDataHooks';
// Read-only browse. Government orgs are reference data (USAspending-seeded
// hierarchy plus tenant additions) whose writes stay admin-coarse until the
// W1-B registries capability cut decides the member write gate — so this tab
// deliberately ships without create/edit/delete affordances.
const COLUMNS = [
    {
        key: 'name',
        header: 'Name'
    },
    {
        key: 'acronym',
        header: 'Acronym',
        render: (o)=>o.acronym || '—'
    },
    {
        key: 'orgType',
        header: 'Type',
        render: (o)=>o.orgType || '—'
    },
    {
        key: 'path',
        header: 'Path',
        render: (o)=>o.displayPath || '—'
    }
];
export function GovernmentOrgsTab() {
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 300);
    // Roots (departments/agencies) by default; a search fans out across the
    // whole hierarchy server-side — same shape the program org picker uses.
    const orgsQuery = useGovernmentOrganizations({
        rootsOnly: true,
        search: debouncedSearch
    });
    const orgs = orgsQuery.data ?? [];
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraInput, {
                "data-testid": Testids.deliveryRegistries.governmentOrgSearchInput,
                placeholder: "Search agencies and offices by name",
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                className: "max-w-sm"
            }),
            /*#__PURE__*/ _jsx(EntityTable, {
                data: orgs,
                columns: COLUMNS,
                testid: Testids.deliveryRegistries.governmentOrgsTable,
                rowTestid: Testids.deliveryRegistries.governmentOrgRow,
                rowKey: (o)=>o.id,
                isLoading: orgsQuery.isLoading,
                error: orgsQuery.error,
                onRetry: orgsQuery.refetch,
                hideRowActions: true,
                emptyState: /*#__PURE__*/ _jsx(EmptyState, {
                    title: "No government organizations",
                    description: debouncedSearch ? 'No agencies or offices match that search.' : 'Government organizations appear here once reference data is loaded.'
                })
            })
        ]
    });
}
